<template>
  <v-menu
    bottom
    offset-y
    transition="slide-y-transition"
  >
    <template #activator="menu">
      <v-tooltip bottom>
        <template #activator="tooltip">
          <v-btn
            v-bind="{ ...defaultAttrs, ...menu.attrs, ...tooltip.attrs, ...$attrs }"
            v-on="{ ...menu.on, ...tooltip.on, ...$listeners }"
          >
            <slot name="default">
              <v-icon>{{ iconName }}</v-icon>
            </slot>
          </v-btn>
        </template>
        <span v-if="tooltip">{{ tooltip }}</span>
      </v-tooltip>
    </template>

    <v-list>
      <v-list-item
        v-for="(item, index) in links"
        :key="index"
        :to="item.to"
      >
        <v-list-item-icon>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title>{{ $t(item.title) }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: "MenuButton",
  props: {
    iconName: {
      type: String,
      default: "mdi-menu"
    },
    links: {
      type: Array,
      default: () => []
    },
    tooltip: {
      type: String
    },
    vBtnClass: {
      type: String,
      default: "text-caption font-weight-bold"
    }
  },
  data() {
    return {
      defaultAttrs: {
        class: this.vBtnClass,
        icon: true
      }
    }
  }
}
</script>
